import { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { api } from "../lib/api";
import { useContent } from "../lib/content";
import { toast } from "sonner";

export default function Contacto() {
  const { t } = useContent();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      setSent(true);
      toast.success(t("contacto_success"));
    } catch {
      toast.error("No se pudo enviar el mensaje");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="contacto-page" className="min-h-screen">
      <Navbar />
      <section className="pt-32 pb-20 max-w-2xl mx-auto px-6">
        <p className="overline mb-3">{t("contacto_overline")}</p>
        <h1 className="font-display text-5xl sm:text-6xl text-white font-light tracking-tighter mb-4">
          {t("contacto_title")}
        </h1>
        <p className="text-zinc-400 mb-12 leading-relaxed">{t("contacto_subtitle")}</p>

        {sent ? (
          <div className="card text-center">
            <p className="text-[#C9A25E] text-4xl mb-3">✦</p>
            <p className="font-display text-2xl text-white">{t("contacto_success")}</p>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="contacto-form" className="space-y-5">
            <div>
              <label className="field-label">{t("contacto_label_name")}</label>
              <input required data-testid="contacto-name" className="input-field" value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })} />
            </div>
            <div>
              <label className="field-label">{t("contacto_label_email")}</label>
              <input required type="email" data-testid="contacto-email" className="input-field" value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })} />
            </div>
            <div>
              <label className="field-label">{t("contacto_label_message")}</label>
              <textarea required rows={6} data-testid="contacto-message" className="input-field" value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })} />
            </div>
            <button type="submit" disabled={loading} data-testid="contacto-submit" className="btn-lilac">
              {loading ? "Enviando…" : t("contacto_submit")}
            </button>
          </form>
        )}
      </section>
      <Footer />
    </div>
  );
}
